
import Vue from 'vue'

interface VariantConfig {
	icon: string
	titleKey: string
	messageKey: string
	iconVariant: 'success' | 'error' | 'info'
}

const VARIANT_MAP: Record<string, VariantConfig> = {
	granted: {
		icon: 'check_circle_outline',
		titleKey: 'consent.granted-card.title',
		messageKey: 'consent.granted-card.body',
		iconVariant: 'success'
	},
	declined: {
		icon: 'check_circle_outline',
		titleKey: 'consent.declined-card.title',
		messageKey: 'consent.declined-card.body',
		iconVariant: 'success'
	},
	error: {
		icon: 'cancel',
		titleKey: 'consent.error-card.title',
		messageKey: 'consent.error-card.body',
		iconVariant: 'error'
	},
	info: {
		icon: 'info_outline',
		titleKey: 'consent.status.CONSENT_REMINDED.title',
		messageKey: 'consent.status.CONSENT_REMINDED.body',
		iconVariant: 'info'
	}
}

type Variant = keyof typeof VARIANT_MAP

export default Vue.extend({
	name: 'ConsentStatusCard',
	props: {
		variant: {
			type: String as () => Variant,
			required: true,
			validator: (v: string) => v in VARIANT_MAP
		},
		title: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: ''
		},
		partnerName: {
			type: String,
			default: ''
		},

		status: {
			type: String,
			default: ''
		}
	},
	computed: {
		variantConfig(): VariantConfig {
			return VARIANT_MAP[this.variant as Variant]
		},
		iconVariantClass(): string {
			return `consent-status-card__icon--${this.variantConfig.iconVariant}`
		},
		computedTitle(): string {
			if (this.title) return this.title
			if (this.status) {
				const key = `consent.status.${this.status}.title`
				if (this.$te(key)) return this.$t(key) as string
			}
			const { titleKey } = this.variantConfig
			return titleKey ? (this.$t(titleKey) as string) : ''
		},
		computedMessage(): string {
			if (this.message) return this.message
			if (this.status) {
				const key = `consent.status.${this.status}.body`
				if (this.$te(key)) {
					const params = { partnerName: this.partnerName || '' }
					return this.$t(key, params) as string
				}
			}
			const { messageKey } = this.variantConfig
			if (!messageKey) return ''
			const params = this.variant === 'error' ? { partnerName: this.partnerName || '' } : {}
			return this.$t(messageKey, params) as string
		}
	}
})
